import { render, staticRenderFns } from "./SelecionarInscricaoEstadualModal.vue?vue&type=template&id=66bdc9ba"
import script from "./SelecionarInscricaoEstadualModal.vue?vue&type=script&lang=js"
export * from "./SelecionarInscricaoEstadualModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports